import React, { useEffect, useState } from 'react'
import { Card, Popover } from 'antd-mobile'

import { useTranslation, Trans } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import { useGetGiveawayDetail, useGiveawayTracker } from '@/bizComponents/Giveaway/hook'
import styles from './index.module.less'
import { useSelector } from '@/store'
import { GiveawayActivityStatus } from '@/services/api/giveaway/type'
import { Cross, ArrowRight } from '@yy/one-icon'
import bg1 from '@/static/images/bg_element1.svg'
import bg2 from '@/static/images/bg_element2.svg'

/** 优惠活动卡片 */
export const GiveawayCard: React.FC = () => {
  const { t } = useTranslation()

  const history = useHistory()

  const { trackGiveawayClick } = useGiveawayTracker()

  const uid = useSelector((state) => state.auth.userInfo.uid)

  const { price, effectiveEndTime, effectiveStartTime, seq, status, ruleKey, giveawayForSeller, expireDate } = useGetGiveawayDetail()

  const localKey = `${ruleKey}_${uid}_giveawayCardNeverShow`

  // 活动卡片是否展示
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (status === GiveawayActivityStatus.NotParticipate) {
      setShow(true)
    } else if (status === GiveawayActivityStatus.Received) {
      // 优惠领取成功，同时没设置不再提醒
      // 赠送后，该商家ID 有钱包流水为「充值」记录，或「调账且修改了余额有效期」的记录（含调增调减），该样式不再展示
      // 赠送金额失效日到期后，该样式不再展示
      if (localStorage.getItem(localKey) !== '1' && !giveawayForSeller && dayjs().valueOf() < expireDate) {
        setShow(true)
      }
    }
  }, [expireDate, giveawayForSeller, localKey, status])

  // 是否已成功参与活动
  const hasJoined = status === GiveawayActivityStatus.Received

  const handleNoRemind = () => {
    setShow(false)
    localStorage.setItem(localKey, '1')
  }

  const toQuestionnairePage = () => {
    trackGiveawayClick()
    history.push(`/questionnaire/${seq}`)
  }

  if (!show) {
    return null
  }

  return (
    <Card
      headerStyle={{
        borderBottomWidth: 0,
        padding: '0 0 7px',
        lineHeight: '22px',
        fontSize: 16,
        color: '#fff',
      }}
      bodyStyle={{
        padding: 0,
      }}
      title={
        <div onClick={(e) => e.stopPropagation()}>
          <img src={bg1} className={styles.bg1} />
          <img src={bg2} className={styles.bg2} />
          <span className={styles.title}>{t('promotion.free.tooltips')}</span>
          <Popover content={`${effectiveStartTime} ~ ${effectiveEndTime}`} trigger="click" placement="top">
            <span className={styles.badge}>{t('time.limited')}</span>
          </Popover>
        </div>
      }
      className={styles.card}
      extra={hasJoined && <Cross className={styles.noRemind} onClick={handleNoRemind} />}
      onClick={!hasJoined && toQuestionnairePage}
    >
      <div>
        <div className={styles.left}>
          <Trans
            i18nKey={!hasJoined ? 'promotion.card.joinTip' : 'promotion.card.joinSuccess'}
            values={{
              startTime: effectiveStartTime,
              endTime: !hasJoined ? effectiveEndTime : dayjs(expireDate).format('YYYY-MM-DD'),
              price: price,
            }}
            components={[<span className={styles.price} />]}
          />
        </div>
        {!hasJoined ? (
          <div className={styles.arrowView}>
            <ArrowRight className={styles.arrow} />
          </div>
        ) : null}
      </div>
    </Card>
  )
}

GiveawayCard.displayName = 'GiveawayCard'
